'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import ControlBarPresentationLayout from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarPresentationLayout';
import type { ControlBarPresentation } from '@/constants/control-bar';
type ControlBarProps = {
  children: ReactNode;
  presentation: ControlBarPresentation;
};
export default function ControlBar(t0) {
  const $ = _c(3);
  const {
    children,
    presentation
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== presentation) {
    t1 = <ControlBarPresentationLayout presentation={presentation}>{children}</ControlBarPresentationLayout>;
    $[0] = children;
    $[1] = presentation;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}